module.exports = __webpack_public_path__ + "img/1528099254.e64f30e1.jpg";